// Normalisasi nomor WhatsApp ke E.164, cermin dari kontrak kanonis backend.
// Port dari pdip-mobile `src/utils/phone.ts` (yang sendiri mencerminkan
// `canonicalPhone` di pdip-backend `internal/hooks/phone.go`):
//
// Input yang diterima persis:
//   - seluler lokal Indonesia "08..." (bagian nasional 9-13 digit, awalan 8)
//   - sudah berkode negara "628..." (aturan nasional yang sama)
//   - internasional eksplisit "+..." (7-15 digit, tanpa nol depan)
//
// Hanya pemisah visual ASCII (spasi, tab, strip, titik, kurung) yang dibuang.
// Non-ASCII, huruf, JID/grup, ekstensi, dan nomor nasional telanjang yang
// ambigu DITOLAK, bukan ditebak. Nilai kawat selalu "+" + 7-15 digit.
// Backend tetap otoritatif; modul ini murni agar UI menolak input yang jelas
// salah sebelum request jaringan.

const ASCII_SEPARATOR = /[ \t\-.()]/g;
const DIGITS_ONLY = /^[1-9][0-9]*$/;
const INDONESIAN_NATIONAL = /^8[0-9]{8,12}$/;

function stripSeparators(value) {
  return value.replace(ASCII_SEPARATOR, "");
}

/** Kanonikalisasi nomor WhatsApp Indonesia ke `+62...`, atau mempertahankan
 *  `+...` internasional eksplisit. Kembalikan string kosong bila ambigu. */
export function normalizeWhatsApp(input) {
  const raw = String(input ?? "");
  // Backend menolak setiap non-ASCII sebelum trim; samakan di sini.
  if (/[^\x00-\x7F]/.test(raw)) return "";
  const value = raw.trim();
  if (!value) return "";
  const cleaned = stripSeparators(value);
  if (!cleaned) return "";

  const explicitPlus = cleaned.startsWith("+");
  let digits = explicitPlus ? cleaned.slice(1) : cleaned;
  if (!digits || !/^[0-9]+$/.test(digits)) return "";

  if (explicitPlus) {
    if (digits.startsWith("0")) return "";
  } else if (digits.startsWith("08")) {
    digits = "62" + digits.slice(1);
  } else if (digits.startsWith("62")) {
    // Sudah berkode negara tanpa "+".
  } else if (digits.startsWith("0")) {
    return "";
  } else {
    return "";
  }

  if (!DIGITS_ONLY.test(digits) || digits.length < 8 || digits.length > 15) return "";
  if (digits.startsWith("62")) {
    const national = digits.slice(2);
    if (!INDONESIAN_NATIONAL.test(national)) return "";
  }
  return `+${digits}`;
}

export function isValidWhatsApp(input) {
  return normalizeWhatsApp(input).length > 0;
}
